import { useEditor, EditorContent } from "@tiptap/react";
import "./MessageEditor.scss";
import { MessageEditorMenu } from "./MessageEditorMenu";
import Link from "@tiptap/extension-link";
import StarterKit from "@tiptap/starter-kit";
import { FunctionComponent, useEffect } from "react";

interface Props {
  value: string;
  label?: string;
  onChange: (value: string) => void;
}

export const MessageEditor: FunctionComponent<Props> = ({
  value,
  label,
  onChange,
}) => {
  const editor = useEditor({
    extensions: [
      StarterKit,
      Link.configure({
        openOnClick: false,
        linkOnPaste: true,
      }),
    ],
    content: value,
  });

  useEffect(() => {
    if (editor === null) {
      return;
    }
    const changeHandler = () => onChange(editor.getHTML());
    editor.on("update", changeHandler);
    return () => {
      editor.off("update", changeHandler);
    };
  }, [editor, onChange]);

  return (
    <div>
      {label && <label>{label}</label>}
      <MessageEditorMenu editor={editor} />
      <EditorContent className="message-editor" editor={editor} />
    </div>
  );
};
